// material-ui

import truckappointmentaddicon from '../../../assets/images/truck-appointment-add.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const TruckAppointmentAddIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={truckappointmentaddicon} alt="Truck appointment Add" width="22"  />
    );
};

export default TruckAppointmentAddIcon;